import type { FetchKey } from '@app/src/api/fetchHooks'
import { getLevelLabel } from '@app/src/pages/Assessments/Assessment/utils'
import { SortOrder } from '@app/src/types/filter'
import type { AssessmentLevelNamesType, AssessmentType } from '@app/src/types/resourceExplorer'
import { LabelFormat } from '@app/src/utils/assessmentLevelTranslations'
import { Chip } from '@mui/material'
import React from 'react'
import type { IntlFormatters } from 'react-intl'
import Filter from '../Filter'
import FilterFacetSelect from '../FilterFacetSelect'
import OptionWithLabel from '../OptionWithLabel'
import { Operators } from '../useFilters'

interface Props {
  name: string
  label: string
  levelsCount: number
  assessmentType: AssessmentType
  levelNamesType: AssessmentLevelNamesType
  fetchKey: FetchKey
  facetEndpoint: string
  formatMessage: IntlFormatters['formatMessage']
  shouldFormatLabel?: boolean
}

export const AssessmentFacetFilter: React.FC<Props> = ({
  name,
  label,
  levelsCount,
  assessmentType,
  levelNamesType,
  fetchKey,
  facetEndpoint,
  formatMessage,
  shouldFormatLabel = true,
}) => (
  <Filter operator={Operators.In} name={name}>
    {({ value, onChange }) => (
      <FilterFacetSelect
        size="small"
        multiple
        facetsParam={{
          key: [fetchKey, name],
          endpoint: facetEndpoint,
          facetsParam: [{ name, isEnum: true }],
          sort: { target: 'label', order: SortOrder.ASCENDING },
        }}
        renderOption={(props, option, { selected }) => (
          <OptionWithLabel
            key={option.label}
            props={props}
            label={getLevelLabel(
              option?.label,
              levelsCount,
              assessmentType,
              levelNamesType,
              formatMessage,
              LabelFormat.Basic,
            )}
            multiple
            selected={selected}
          />
        )}
        renderTags={(value, getTagProps) =>
          value?.map(
            (option, index) =>
              option && (
                <Chip
                  {...getTagProps({ index })}
                  key={option.value.toString() || index}
                  label={getLevelLabel(
                    option?.label,
                    levelsCount,
                    assessmentType,
                    levelNamesType,
                    formatMessage,
                    LabelFormat.Basic,
                  )}
                />
              ),
          )
        }
        filterName={name}
        onChange={onChange}
        fieldLabel={shouldFormatLabel ? formatMessage({ id: label }) : label}
        value={[value].flat()}
      />
    )}
  </Filter>
)
